import Icon from '../../../../../../Icon/Icon';
import React, { useEffect, useState, useRef } from 'react';

const Input = (props) => {
    const {
        children,
        label,
        id = '',
        value,
        onChange,
        onValidate,
        placeholder,
        errorMessage,
        submitted,
        type = 'text',
        step = '',
        min = '',
        containerClassName = '',
        autoComplete = '',
    } = props;
    const [isWriting, setIsWriting] = useState(true);
    const [isValid, setIsValid] = useState(true);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const onBlur = async () => {
        const validationResult = await onValidate(value);
        if (isMounted.current) {
            setIsValid(validationResult);
            setIsWriting(false);
        }
        if (props.onBlur) {
            props.onBlur();
        }
    };

    const onFocus = () => {
        setIsWriting(true);
    };

    useEffect(() => {
        if (submitted) {
            onBlur();
        }
    }, [submitted]);

    return (
        <div className={` max-w-sm mx-auto sm:mx-0 ${containerClassName}`}>
            <label htmlFor={id} className="text-sm font-medium text-gray-700">
                {label} {children}
            </label>
            <div className="grid grid-cols-7">
                <input
                    autoComplete={autoComplete}
                    type={type}
                    step={step}
                    min={min}
                    value={value}
                    id={id}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    className={`focus:ring-0 focus:outline-none sm:block col-span-6  sm:w-full sm:text-sm rounded-md ${
                        !isValid && (!isWriting || submitted)
                            ? 'border-red-500'
                            : 'border-gray-300'
                    }`}
                    placeholder={placeholder}
                />
                <div
                    className={`flex justify-end sm:justify-center items-center pl-2 ${
                        isWriting && !submitted ? 'invisible' : ''
                    }`}>
                    {isValid ? (
                        <Icon
                            name="check"
                            fixedWidth
                            className="mr-1 text-green-500"
                        />
                    ) : (
                        <Icon
                            name="times"
                            fixedWidth
                            className="mr-1 text-red-500"
                        />
                    )}
                </div>
            </div>
            {!isValid && (!isWriting || submitted) && errorMessage && (
                <span className="text-red-500 text-xs italic">
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

export default Input;
